import type { IErrorResponse } from '@/types/apis/Error';
import type { Profile } from '@/types/apis/Profile';

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import url from '@/statics/urls';

const useProfile = (): UseQueryResult<Profile, IErrorResponse> => {
  return useQuery<Profile, IErrorResponse>({
    queryKey: [url.profile],
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
export default useProfile;
